// アクリル商品のデザインプレビュー関連のステータス
const initialState = () => ({
    isShowUploadImage: false, // アップロード案内画像を表示するか
    selectProductId: 0,       // 表示する商品の商品ID
    cutlinePreviewMode: 0,    // カットラインの状態（線かそのままか）
    isShowCutline: true,      // カットライン表示
    is3DPreviewMode: true,    // 3Dプレビューかどうか
    selectBackgroundColor:1,  // プレビュー時のカラー
    selectCutlineColor:0,     // プレビュー時のカラー
    designImageURL:null,            // プレビュー用デザインの画像
    cutlineImagePngURL: null,       // 入稿された状態のカットラインデータ(png)
                                    // このデータを元にselectCutlineColorを適応した、originalCutlineImageURLとcutlineContourImageURLを生成
    originalCutlineImageURL: null,  // プレビュー用カットラインデータ(塗)
    cutlineContourImageURL: null,   // プレビュー用カットラインデータ(線)
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    reset(state) {
      Object.assign(state, initialState())
    },
    set(state, { key, value }) {
      if (key in state) {
        state[key] = value;
      }
    },
  },
}
